import React from 'react';
import { InlineMath, BlockMath } from 'react-katex';
import EquationInput from '../../../../components/inputs/EquationInput';

// ==== GENERATOR ====
export function generateTask() {
  const variables = ['x', 'y', 'z'];
  const variable = variables[Math.floor(Math.random() * variables.length)];

  const a = Math.floor(Math.random() * 9) + 1;
  const b = Math.floor(Math.random() * 9) + 1;

  const leftFirst = Math.random() < 0.5; // true: ax - b, false: b - ax

  const aTerm = a === 1 ? variable : `${a}${variable}`;
  const expression = leftFirst ? `(${aTerm} - ${b})^2` : `(${b} - ${aTerm})^2`;

  const leftTerm = a ** 2 === 1 ? `${variable}^2` : `${a ** 2}${variable}^2`;
  const middleTerm = 2 * a * b === 1 ? `${variable}` : `${2 * a * b}${variable}`;
  const expected = `${leftTerm} - ${middleTerm} + ${b ** 2}`;

  return {
    type: 'SquareOfDifferenceTask',
    data: { variable, a, b, leftFirst, expression, expected }
  };
}

// ==== RENDER TASK ====
export function renderTask({ data }) {
  return (
    <p>
      Uprość wyrażenie: <InlineMath math={data.expression} />
    </p>
  );
}

// ==== INPUT ====
export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <EquationInput value={userAnswer} onChange={onChange} disabled={disabled} />
  );
}

// ==== CHECK ====
export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== 'string') {
    return { isCorrect: false, expected: data.expected };
  }

  const normalize = (str) =>
    str
      .replace(/−/g, '-')       // różne minusy
      .replace(/\s+/g, '')
      .replace(/\*/g, '')
      .replace(/-/g, '+-')      // rozbicie na składniki
      .toLowerCase()
      .split('+')
      .filter(Boolean)
      .sort()
      .join('+');

  return {
    isCorrect: normalize(userAnswer) === normalize(data.expected),
    expected: data.expected
  };
}

// ==== ANSWER ====
export function renderAnswer({ data }) {
  return <InlineMath math={data.expected} />;
}

// ==== EXPLANATION ====
export function renderExplanation({ data }) {
  const { a, b, variable, expected, leftFirst } = data;

  const aText = a === 1 ? variable : `${a}${variable}`;
  const binomial = leftFirst ? `(${aText} - ${b})^2` : `(${b} - ${aText})^2`;

  // Podstawienie do wzoru bez liczenia:
  // (ax - b)^2 = (ax)^2 - 2·(ax)·b + b^2  (gdy a=1: x^2 - 2·x·b + b^2)
  const sqLeft = a === 1 ? `${variable}^2` : `(${a}${variable})^2`;
  const midLeft = a === 1 ? `${variable}` : `(${a}${variable})`;
  const substitution = `${sqLeft} - 2\\cdot ${midLeft} \\cdot ${b} + ${b}^2`;

  return (
    <div className='space-y-2'>
      <p><strong>Krok 1:</strong> Wzór skróconego mnożenia:</p>
      <BlockMath math={'(a - b)^2 = a^2 - 2ab + b^2'} />
      <p><strong>Krok 2:</strong> Podstawiamy i liczymy:</p>
      <BlockMath math={`${binomial} = ${substitution} = ${expected}`} />
    </div>
  );
}

// ==== RENDER USER ANSWER ====
export function renderUserAnswer(...args) {
  const ua = args.length === 1 ? args[0] : args[1];
  const raw = typeof ua === 'string' ? ua : ua?.raw;
  if (!raw || raw.trim() === '') return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={raw} />;
}
